import {PageComponentClass, PageComponentInterface} from "./PageComponentInterface";
import {PageSeoClass, PageSeoInterface} from "./PageSeoInterface";

export interface PageParentChildrenInterface {
	title: string;
	permalink: string;
}

export interface PageDataInterface {
	title: string,
	permalink: string,
	type: string,
	components: PageComponentInterface[],
	seo: PageSeoInterface[],
	children: PageParentChildrenInterface[];
	parent: PageParentChildrenInterface;
}

export class PageDataClass implements PageDataInterface {
	title = '';
	permalink = '';
	type = '';
	components = [new PageComponentClass()];
	seo = [new PageSeoClass()];
	children = [];
	parent = {title: '', permalink: ''};
}
